module.exports = __webpack_public_path__ + "static/media/screen-youtube-altyor.4d39c2b5.png";